import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import navList from "../assets/images/data/navItem";
import { logout } from "../redux/userRedux";

export default function Sidebar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [appointmentsOpen, setAppointmentsOpen] = useState(
    location.pathname.startsWith("/appointments")
  );

  const isActive = (path) => location.pathname === path;
  const isParentActive = (paths) =>
    paths.some((p) => location.pathname.startsWith(p));

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const closeSidebarOnMobile = () => {
    if (window.innerWidth < 1200) {
      document.body.classList.remove("toggle-sidebar");
    }
  };

  return (
    <>
      {/* Backdrop for mobile */}
      <div
        className="sidebar-backdrop"
        onClick={() => document.body.classList.remove("toggle-sidebar")}
      />

      <aside id="sidebar" className="sidebar">
        <nav className="sidebar-nav">

          {/* ── MAIN section ── */}
          <p className="sidebar-section-label">Main</p>

          <Link
            to="/"
            className={`sidebar-item ${isActive("/") ? "sidebar-item--active" : ""}`}
            onClick={closeSidebarOnMobile}
          >
            <span className="sidebar-item-icon">
              <i className="bi bi-grid-fill" />
            </span>
            <span className="sidebar-item-label">Dashboard</span>
          </Link>

          {/* Appointments collapsible */}
          <div className="sidebar-group">
            <button
              className={`sidebar-item sidebar-item-toggle ${
                isParentActive(["/appointments"]) ? "sidebar-item--active" : ""
              }`}
              onClick={() => setAppointmentsOpen((o) => !o)}
              aria-expanded={appointmentsOpen}
            >
              <span className="sidebar-item-icon">
                <i className="bi bi-calendar2-check" />
              </span>
              <span className="sidebar-item-label">Appointments</span>
              <i
                className={`bi bi-chevron-down sidebar-chevron ${
                  appointmentsOpen ? "sidebar-chevron--open" : ""
                }`}
              />
            </button>

            <div className={`sidebar-sub ${appointmentsOpen ? "sidebar-sub--open" : ""}`}>
              <Link
                to="/appointments/appointment-list"
                className={`sidebar-sub-item ${
                  isActive("/appointments/appointment-list") ? "sidebar-sub-item--active" : ""
                }`}
                onClick={closeSidebarOnMobile}
              >
                <span className="sidebar-sub-dot" />
                Appointment List
              </Link>
            </div>
          </div>

          {/* ── MANAGEMENT section ── */}
          {navList.length > 0 && (
            <p className="sidebar-section-label" style={{ marginTop: "1rem" }}>
              Management
            </p>
          )}

          {navList.map((nav) => (
            <Link
              key={nav._id}
              to={nav.url}
              className={`sidebar-item ${isActive(nav.url) ? "sidebar-item--active" : ""}`}
              onClick={closeSidebarOnMobile}
            >
              <span className="sidebar-item-icon">
                <i className={nav.icon} />
              </span>
              <span className="sidebar-item-label">{nav.name}</span>
            </Link>
          ))}

          {/* ── Logout ── */}
          <div className="sidebar-footer">
            <div className="sidebar-divider" />
            <button className="sidebar-item sidebar-item--logout" onClick={handleLogout}>
              <span className="sidebar-item-icon">
                <i className="bi bi-box-arrow-right" />
              </span>
              <span className="sidebar-item-label">Sign Out</span>
            </button>
          </div>

        </nav>
      </aside>
    </>
  );
}
